<template>
  <DialogFull
    :data="dialogSettings"
    v-if="dialogSettings.dialog"
    @close="close"
  >
    <template v-slot:dialog.body>
      <div class="container mt-10">
        <h1>{{ dialogSettings.title }}</h1>
        <InterviewFormatTemplateForm
          ref="interviewFormatTemplate"
          @onSubmit="createTemplate"
        />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton
        @click.native="validateForm"
        :loading="isAddingInterviewTemplate"
      >
        Create Interview Template
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { ORGANISATION_INTERVIEW_FORMAT_TEMPLATES_NAMESPACE } from "@/store/modules/organisations/organisation-interview-format-templates";
import { CREATE_INTERVIEW_FORMAT_TEMPLATE } from "@/store/modules/organisations/organisation-interview-format-templates/actions";
import InterviewFormatTemplateForm from "@/views/settings/components/interview-format-templates/components/InterviewFormatTemplateForm";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { GET_CURRENT_ORGANISATION_ID } from "@/store/modules/auth/getters";

const { mapGetters: mapAuthGetters } = createNamespacedHelpers(AUTH_NAMESPACE);
const { mapActions } = createNamespacedHelpers(
  ORGANISATION_INTERVIEW_FORMAT_TEMPLATES_NAMESPACE
);
export default {
  props: {
    isOpen: Boolean
  },
  components: {
    PrimaryButton,
    DialogFull,
    InterviewFormatTemplateForm
  },
  data() {
    return {
      isAddingInterviewTemplate: false
    };
  },
  computed: {
    ...mapAuthGetters({
      userOrganisationId: GET_CURRENT_ORGANISATION_ID
    }),
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "New Interview Template"
      };
    }
  },
  methods: {
    ...mapActions({
      createInterviewTemplate: CREATE_INTERVIEW_FORMAT_TEMPLATE
    }),
    validateForm() {
      this.$refs.interviewFormatTemplate.validateForm();
    },
    async createTemplate(templateData) {
      this.isAddingInterviewTemplate = true;
      await this.createInterviewTemplate({
        ...templateData,
        organisation: {
          id: this.userOrganisationId
        }
      });
      this.close();
      this.isAddingInterviewTemplate = false;
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
